var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"large":"","outlined":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.$tc('time'))+" "+_vm._s(_vm.splitTime.hours)+":"+_vm._s(_vm.splitTime.minutes)+":"+_vm._s(_vm.splitTime.seconds)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }